import React from "react";
import { Container } from "./styles";

const Padding = () => {
	return <Container />;
};

export default Padding;
